import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandHoldingDollar } from '@fortawesome/free-solid-svg-icons';

export const ContactInfo = ({ data }) => {
  return (
    <div className="col-md-4">
      <div className="contact-info">
        <h3>Contact Info</h3>
        <ContactItem
          icon="fa-map-marker"
          label="Address"
          href={data ? "https://www.google.com/maps/search/?api=1&query=51.521733338954164%2C-0.650387345179031" : "loading"}
          text={data ? data.address : "loading"}
        />
        <ContactItem
          icon="fa-phone"
          label="Phone"
          href={data ? "tel:" + data.phone : "loading"}
          text={data ? data.phone : "loading"}
        />
        <ContactItem
          icon="fa-envelope-o"
          label="Email"
          href={data ? "mailto:" + data.email : "loading"}
          text={data ? data.email : "loading"}
        />
        <ContactItem
          icon="fa-whatsapp"
          label="Whatsapp"
          href={data ? data.whatsapp : "loading"}
          text="Click to Join our group"
        />
        <div className="contact-item">
          <a href={data ? data.charity : "loading"} target="_blank" rel="noreferrer">
            <span>
              <FontAwesomeIcon icon={faHandHoldingDollar} /> Charity
            </span>{" "}
            Charity Number: 1079416
          </a>
        </div>
      </div>
    </div>
  );
};

const ContactItem = ({ icon, label, href, text }) => (
  <div className="contact-item">
    <a href={href} target="_blank" rel="noreferrer">
      <span>
        <i className={`fa ${icon}`}></i> {label}
      </span>
      {text}
    </a>
  </div>
);
